<app-dashboard-card
	title="Revenue Summary"
	icon="pi pi-chart-line"
>
	<div class="revenue-table-wrapper">
		<table class="revenue-table">
			<thead>
			<tr>
				<th>Revenue</th>
				<th>Day</th>
				<th>Last Year</th>
				<th>Budget</th>
			</tr>
			</thead>

			<tbody>
			<tr
				*ngFor="let row of rows; first as isFirst"
				[class.revenue-total]="isFirst"
			>
				<td>{{ row.label }}</td>

				<td>
					{{ row.day | number: '1.0-0' }}
				</td>

				<td>
					{{ row.lastYear | number: '1.0-0' }}
				</td>

				<td>
					{{ row.budget | number: '1.0-0' }}
				</td>
			</tr>
			</tbody>
		</table>
	</div>
</app-dashboard-card>
